import { Action } from '../actions';

export default function (logState = {}, action) {
  const { body } = action.payload || {};
  switch (action.type) {
    case Action.System.Logs.LoadCompleted:
    case Action.System.Logs.DetailCompleted:
      if (body.requests) {
        return {
          ...logState,
          loading: false,
          rows: body.requests || logState.rows,
          details: {
            ...logState.details,
            ...body.logs,
          },
        };
      }
      if (body.logs) {
        return {
          ...logState,
          loading: false,
          details: {
            ...logState.details,
            ...body.logs,
          },
        };
      }
      break;
    case Action.System.Logs.LoadPending:
      if (!logState.loading) {
        return {
          ...logState,
          loading: true,
        };
      }
      break;
    case Action.System.Logs.ForgetDetails:
      if (logState.details && logState.details[action.payload]) {
        return {
          ...logState,
          details: {
            ...logState.details,
            [action.payload]: null,
          },
        };
      }
      break;
    default:
      break;
  }
  return logState;
}
